export enum PositionSelectionGroupItemType {
  Overview = 'OVERVIEW',
  Matches = 'MATCHES',
  Outreach = 'OUTREACH',
}
